import React, { useState } from "react";
import { Modal, Button, Form, Spinner, Alert } from "react-bootstrap";
import { getTelemetryData } from "../../services/telemetry";
import { API_BASE_URL } from "../../config";

const BugReportModal = () => {
  const [show, setShow] = useState(false);
  const [description, setDescription] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null); // 'success' or 'error'

  const handleClose = () => {
    setShow(false);
    setStatus(null);
    setDescription("");
  };

  const handleShow = () => setShow(true);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);

    try {
      const telemetry = getTelemetryData();
      
      // Attempt to grab Redux/Context state from localStorage if available
      let stateSnapshot = {};
      try {
        stateSnapshot = {
          // Add any safe localstorage items here. e.g.
          // theme: localStorage.getItem('theme'),
        };
      } catch(err) {}

      // Try to determine email if logged in (if email is empty and we can extract it)
      // Usually the user would fill it if it's required.

      const payload = {
        email,
        description,
        metadata: telemetry.metadata,
        logs: telemetry.logs,
        stateSnapshot
      };

      // Ensure API allows anonymous submissions or pass token if available
      // The backend route handles it automatically if auth is optional.
      const response = await fetch(`${API_BASE_URL}/bug-reports`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem("token") || ""}`
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json();
      if (data.success) {
        setStatus("success");
        setDescription("");
      } else {
        setStatus("error");
      }
    } catch (error) {
      console.error("Bug report submission failed:", error);
      setStatus("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div 
        style={{
          position: "fixed",
          bottom: "30px",
          right: "30px",
          zIndex: 9999
        }}
      >
        <Button 
          className="shadow d-flex justify-content-center align-items-center" 
          onClick={handleShow}
          style={{ 
            width: "60px", 
            height: "60px", 
            borderRadius: "30px", 
            padding: 0,
            backgroundColor: "#dc2626", // Red to stand out
            borderColor: "#dc2626",
            color: "white"
          }}
          title="Report an Issue"
        >
          <i className="fas fa-question" style={{ fontSize: "28px" }}></i>
        </Button>
      </div>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Report an Issue</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {status === "success" && (
            <Alert variant="success">
              Your bug report has been submitted successfully! Our dev team has been notified.
            </Alert>
          )}
          {status === "error" && (
            <Alert variant="danger">
              Failed to submit the bug report. Please try again later.
            </Alert>
          )}

          {!status && (
            <Form onSubmit={handleSubmit}>
              <p className="text-muted small mb-3">
                When you submit this form, we will automatically capture your browser details, current URL, and recent error logs to help us troubleshoot faster.
              </p>
              <Form.Group className="mb-3">
                <Form.Label>Your Email Address</Form.Label>
                <Form.Control
                  type="email"
                  required
                  placeholder="name@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>What happened?</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  required
                  placeholder="Describe what you were trying to do and what went wrong..."
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </Form.Group>
              <Button variant="danger" type="submit" disabled={loading} className="w-100">
                {loading ? <Spinner animation="border" size="sm" /> : "Submit Bug Report"}
              </Button>
            </Form>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default BugReportModal;
